// extracted by mini-css-extract-plugin
module.exports = {"padding":"0","default-padding":"X7Ws1","defaultPadding":"X7Ws1"};